/* globals window $ */

// https://stackoverflow.com/questions/5489946/jquery-how-to-wait-for-the-end-of-resize-event-and-only-then-perform-an-ac

/**
 * ResizeEnd
 * @return {Object}
 */
const resizeEnd = () => {
  const $window = $(window);
  const delta = 200;

  let timeout = false;
  let rtime;

  /**
   * Constructor
   */
  function constructor() {
    bindEvents();
  }

  /**
   * Bind handlers to events
   */
  function bindEvents() {
    $window.resize(onResize);
  }

  /**
   * Resize end handler
   */
  function resizeEnd() {
    if (new Date() - rtime < delta) {
      setTimeout(resizeEnd, delta);
    } else {
      timeout = !timeout;
      $window.trigger('resizeEnd');
    }
  }

  /**
   * Resize event handler
   */
  function onResize() {
    rtime = new Date();

    if (timeout === false) {
      timeout = !timeout;
      setTimeout(resizeEnd, delta);
    }
  }

  constructor();

  return {};
};

export default resizeEnd();



// WEBPACK FOOTER //
// ./resources/assets/js/utils/resizeEnd.js